module.exports = __webpack_public_path__ + "img/toad-pad.0c59c5bd.svg";